/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import '@babel/polyfill';
import axios from 'axios';
import CKEditor from '@ckeditor/ckeditor5-vue';
import store from './store';
import Vue from 'vue';
import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';
import { registerComponents } from './components';

let revision = process.env.MIX_COMMIT_REVISION || 'local';
let bugsnagClient = bugsnag({
  apiKey: process.env.MIX_BUGSNAG_VUE_API_KEY,
  releaseStage: process.env.MIX_APP_ENV,
  appVersion: revision,
});
bugsnagClient.use(bugsnagVue, Vue);

window.Vue = Vue;
window._ = require('lodash');
window.bugsnagClient = bugsnagClient;
require('./bootstrap');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(CKEditor);
Vue.prototype.$http = axios;
Vue.prototype.bugsnagClient = bugsnagClient;

registerComponents(Vue);

const app = new Vue({
  el: '#app',
  store,
  data: {},
});
